export const DATE_FORMATS = {
	standard: "MM/DD/YYYY",
}